<header nx-header>
  <nx-header-row>
    <nx-header-navigation>
      <ng-container *ngFor="let item of menuItemList | isActiveCheck">
        <nx-header-navigation-item *ngIf="!(userRole=='Dealer' && item.route=='/dealerclaim')">
          <a [routerLink]="item.route" routerLinkActive="is-active" nxHeaderLink>{{item.displayName}}</a>
        </nx-header-navigation-item>
      </ng-container>

      <nx-header-navigation-item *ngIf="userRole=='Dealer' && showWrkspLink">
        <a routerLinkActive="is-active" target="_blank" nxHeaderLink [routerLink]="['/registration']"
          [queryParams]="{ login: 'workshop'}">
          WorkShop Registration
        </a>
      </nx-header-navigation-item>

    </nx-header-navigation>
  </nx-header-row>
</header>
<app-changepassword></app-changepassword>